import { css } from '@emotion/react';
import { token } from '@atlaskit/tokens';
import { N0 } from '@atlaskit/theme/colors';

export const rootContainerStyle = css`
  position: relative;
  background-color: ${token('elevation.surface', N0)};
  border-radius: 10px;
  max-width: 874px;
  height: 736px;
  padding: 26px 18px;
  overflow: visible;
`;

export const boardHeaderStyle = css`
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const rightButtonGroupStyle = css`
  display: flex;
`;

export const buttonDividerStyle = css`
  background-color: ${token('color.icon')};
  margin-left: 16px;
  margin-right: 4px;
  width: 1px;
`;

export const rotateRestartButtonStyle = css`
  :hover svg,
  :focus svg {
    transform: rotate(90deg);
  }
  svg {
    transition: 0.3s;
    @media screen and (prefers-reduced-motion: reduce) {
      transition: none;
    }
  }
`;

export const leftSlideCreateButtonStyle = css`
  @keyframes slideLeft {
    from {
      transform: translateX(142px);
    }
    to {
      transform: translateX(0px);
    }
  }
  animation: 500ms ease-in slideLeft;
`;

export const wiggleCreateButtonStyle = css`
  @keyframes hiThere {
    15% {
      transform: scale(1.2);
    }
    20%,
    30% {
      transform: rotate(-20deg) scale(1.2);
    }
    25% {
      transform: rotate(20deg) scale(1.2);
    }
    35% {
      transform: rotate(0deg) scale(1.2);
    }
    50% {
      transform: scale(1);
    }
  }
  animation: 4s ease hiThere infinite;
`;

export const fadeInRestartButtonStyle = css`
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  opacity: 0;
  animation: 1s ease-in fadeIn 500ms forwards;
`;

export const boardBodyStyle = css`
  border-radius: 8px;
  height: calc(100% - 56px);
  overflow-y: auto;
`;

export const columnContainerStyle = css`
  display: flex;
  gap: 12px;
  min-height: 100%;
`;

export const columnTitleStyle = css`
  background-color: ${token('elevation.surface.sunken')};
  color: ${token('color.text.subtle', '#9FADBC')};
  font-size: 12px;
  font-weight: 600;
  padding: 16px;
  text-transform: uppercase;
  margin: 0px;
  line-height: 1.33333333;
`;

export const columnStyle = css`
  background-color: ${token('elevation.surface.sunken')};
  border-radius: 8px;
  flex: 1 1 0px;
  padding-left: 5px;
  padding-right: 5px;
  min-height: 622px;
`;
